var _defs, _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGender(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 114.78 114.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#11ccea;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 57.39,
    cy: 57.39,
    r: 57.39
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m59.3,72.02c3.46-3.81,5.61-7.76,6.19-12.52,1.27-10.57-6.62-20.42-17.5-21.67-10.91-1.26-20.79,7.17-21.66,18.45-.8,10.39,7.61,20.35,18.06,20.5,4.51.07,6.51,3.01,9.98,5.26-4.75,1.9-9.06,1.93-13.32,1.12-13.35-2.52-22.84-15.28-21.2-28.29,1.82-14.42,13.29-24.25,27.6-23.66,13.39.56,24.38,11.87,24.73,25.55.14,5.38-1.29,10.38-4.23,14.91-2.09,3.22-2.37,3.31-5.85,1.82-.81-.35-1.58-.82-2.8-1.46h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m55.52,42.85c-4.48,4.78-6.6,9.96-6.15,16.11.72,9.87,8.77,17.65,18.73,18.02,10.46.38,19.01-6.97,20.36-17.48,1.21-9.45-5.46-18.97-14.86-21.17-.97-.23-1.95-.41-2.94-.5-4.65-.46-6.02-1.15-9.77-5.14,3.56-1.67,7.22-1.75,10.85-1.36,13.48,1.45,23.52,12.9,23.38,26.51-.14,13.16-10.47,24.45-23.42,25.6-13.91,1.24-26-7.63-28.55-21.12-1.27-6.75-.07-13.14,3.64-18.99,2.18-3.44,2.56-3.55,6.28-1.85.72.33,1.38.77,2.45,1.37h0Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGender);
export default __webpack_public_path__ + "static/media/gender.2772bc25ff8358c05f29bb0468187243.svg";
export { ForwardRef as ReactComponent };